module.exports = __webpack_public_path__ + "static/3BHK-07-Bedroom-02-ff0060a4c40d600b60210d2cb5eac281.jpg";